import React, { useEffect } from 'react'
import { resetStore } from 'App/helpers/meteor-apollo-accounts/store'
import { useNavigate, useLocation } from 'react-router-dom'

const InvalidToken = () => {
  const navigate = useNavigate()
  const location = useLocation()

  useEffect(() => {
    resetStore()
    navigate('/login' + location.search)
  }, [navigate, location])

  return <span />
}

export default InvalidToken
